import {useEffect} from 'react'
import {
  get_utm_from_url,
  store_first_touch,
  store_last_touch,
} from '../utils/attribution'

/**
 * Hook that captures UTM parameters and click IDs on mount.
 * - First-touch: stored in localStorage (never overwritten)
 * - Last-touch: stored in sessionStorage (updated each session)
 *
 * Place this in _app.tsx so it runs on every page load.
 */
export function useAttribution() {
  useEffect(() => {
    const attribution_data = get_utm_from_url()
    if (!attribution_data) return

    store_first_touch(attribution_data)
    store_last_touch(attribution_data)
  }, []) // only on mount
}
